import axios from "axios";

const API_BASE_URL =
  process.env.NEXT_PUBLIC_API_BASE_URL || "https://api-dev.dsec.jp";
const API_KEY = process.env.NEXT_PUBLIC_API_KEY || "";

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "X-API-Key": API_KEY,
  },
});

// レスポンスインターセプター
apiClient.interceptors.response.use(
  (response) => ({
    data: response.data,
    status: response.status,
  }),
  (error) => {
    if (error.response) {
      // エラーレスポンスの処理
      console.error("API Error:", error.response.data);
      return {
        data: error.response.data,
        status: error.response.status,
      };
    }
    return Promise.reject(error);
  }
);
